import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {showPosition, emptyPosition} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';

@connect((state) => ({
  position: state.FormBuilder.Common.DepartmentList.position,
}), {
  showPosition,
  emptyPosition,
})
@autobind
/**
 *
 */
export default class DepartmentListInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    positionId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    position: PropTypes.object,
    showPosition: PropTypes.func,
    emptyPosition: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      position: {},
      render: true,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {showPosition} = this.props;
    showPosition(this.props.positionId, (r) => {
      this.setState({position: r});
    });
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.positionId, this.props.positionId)) {
      np.showPosition(np.positionId, (r) => {
        this.setState({position: r});
      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyPosition();
  }


  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {position, label} = this.props;

    return (
      <span>
        {`${position && position.name }`}
        </span>
    );
  }
}
